import { Button } from '@mui/material';
import { notificationService } from '@pn/services/notifications';
import { isNil } from 'lodash-es';
import React from 'react';
import { registerSW } from 'virtual:pwa-register';

export function useServiceWorker() {
  React.useEffect(() => {
    const updateSW = registerSW({
      onNeedRefresh() {
        if (!isNil(notificationService.get('sw-update'))) return;

        notificationService.render({
          content: 'New version available',
          action: (
            <Button
              size="small"
              onClick={() => {
                updateSW();
                notificationService.remove('sw-update');
              }}
            >
              Reload
            </Button>
          ),
          options: {
            id: 'sw-update',
          },
        });
      },
    });
  }, []);

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (
        'serviceWorker' in navigator &&
        document.visibilityState === 'visible'
      ) {
        navigator.serviceWorker.getRegistration().then((reg) => {
          reg?.update();
        });
      }
    }, 60e3); /* 1 minute */

    return () => clearInterval(interval);
  }, []);
}
